import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './MediaQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AboutUsSubpageMediaQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type AboutUsSubpageMediaQuery = (
  { __typename?: 'Query' }
  & { pagesAboutUs?: Types.Maybe<(
    { __typename?: 'AboutEntity' }
    & { media?: Types.Maybe<(
      { __typename?: 'EntityMediaConnection' }
      & { edges?: Types.Maybe<Array<Types.Maybe<(
        { __typename?: 'EntityMediaEdge' }
        & { node: (
          { __typename?: 'EntityMedia' }
          & Pick<Types.EntityMedia, 'id' | 'description'>
          & { media?: Types.Maybe<(
            { __typename?: 'EntityExternalVideo' }
            & Pick<Types.EntityExternalVideo, 'url' | 'externalLink'>
          ) | (
            { __typename?: 'EntityVideo' }
            & Pick<Types.EntityVideo, 'videoReferenceV2'>
          ) | (
            { __typename?: 'ScaledImage' }
            & Pick<Types.ScaledImage, 'url'>
          )> }
        ) }
      )>>> }
    ) | (
      { __typename?: 'EntityPageError' }
      & Pick<Types.EntityPageError, 'errorType' | 'errorCode'>
    )> }
  ) | { __typename?: 'EntityPageError' }> }
);



/**
 * __useAboutUsSubpageMediaQuery__
 *
 * To run a query within a React component, call `useAboutUsSubpageMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutUsSubpageMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutUsSubpageMediaQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAboutUsSubpageMediaQuery(baseOptions: Apollo.QueryHookOptions<AboutUsSubpageMediaQuery, AboutUsSubpageMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AboutUsSubpageMediaQuery, AboutUsSubpageMediaQueryVariables>(Operations.AboutUsSubpageMedia, options);
      }
export function useAboutUsSubpageMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AboutUsSubpageMediaQuery, AboutUsSubpageMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AboutUsSubpageMediaQuery, AboutUsSubpageMediaQueryVariables>(Operations.AboutUsSubpageMedia, options);
        }
export type AboutUsSubpageMediaQueryHookResult = ReturnType<typeof useAboutUsSubpageMediaQuery>;
export type AboutUsSubpageMediaLazyQueryHookResult = ReturnType<typeof useAboutUsSubpageMediaLazyQuery>;
export type AboutUsSubpageMediaQueryResult = Apollo.QueryResult<AboutUsSubpageMediaQuery, AboutUsSubpageMediaQueryVariables>;